module.exports = __webpack_public_path__ + "img/40_70_001_485.8cb04b58.jpg";